import { combineReducers } from '@reduxjs/toolkit'

import {
  domainUsersListReducer,
  updateUserPermissionsReducer,
} from 'features/team/slice'
import {
  DOMAIN_USERS_LIST_REDUCER_NAME,
  UPDATE_USER_PERMISSIONS_REDUCER_NAME,
} from 'features/team/consts'

export default combineReducers({
  [DOMAIN_USERS_LIST_REDUCER_NAME]: domainUsersListReducer,
  [UPDATE_USER_PERMISSIONS_REDUCER_NAME]: updateUserPermissionsReducer,
})
